import { useEffect } from "react";
import { initSmoothScroll, destroySmoothScroll, scrollToId } from "@/lib/scroll";

const HASH_SCROLL_DELAY_MS = 350;

/**
 * Boots Lenis smooth scrolling for the lifetime of the page and honours a #hash deep link on load.
 */
export function useSmoothScroll() {
  useEffect(() => {
    initSmoothScroll();
    const hash = window.location.hash.replace("#", "");
    const timer = hash ? window.setTimeout(() => scrollToId(hash), HASH_SCROLL_DELAY_MS) : null;

    return () => {
      if (timer) window.clearTimeout(timer);
      destroySmoothScroll();
    };
  }, []);
}
